import React from "react";
import PropTypes from "prop-types";
import PropertyBox from "components/elements/property-box";
import SVG from "components/elements/svg";
import PropertyPropType from "helpers/prop-types/property-index";

class PropertyList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      properties: props.properties,
    };
  }

  componentDidMount() {
    const { pusher } = window;
    this.socket = pusher.subscribe("properties-channel");
    this.socket.bind("property.status.updated", (event) => {
      if (
        event.data.property.newStatus === "sold" ||
        event.data.property.newStatus === "ended"
      ) {
        const { properties } = this.state;
        const newProperties = properties.filter(
          (item) => item.id !== event.data.property.id,
        );
        this.setState({ properties: newProperties });
      }
    });
  }

  UNSAFE_componentWillReceiveProps({ properties }) {
    this.setState({ properties });
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.unbind();
    }
  }

  render() {
    const { properties } = this.state;
    return (
      <div className="properties-list row">
        {properties &&
          properties.map((property) => (
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
              key={property.id}
            >
              <PropertyBox property={property} countdownTheme="dark" />
            </div>
          ))}

        {properties.length === 0 && (
          <div className="section-heading text-center properties-list__no-results">
            <div className="icon-container">
              <SVG src="loop-icon" className="icon loop-icon" />
            </div>
            <h2> No properties found. </h2>
            <p>
              Please change your criteria or search radius to find other
              properties you may like.
            </p>
          </div>
        )}
      </div>
    );
  }
}

PropertyList.propTypes = {
  properties: PropTypes.arrayOf(PropertyPropType),
};

PropertyList.defaultProps = {
  properties: [],
};

export default PropertyList;
